import React, { useRef, useState } from 'react';
import './ExplainerVideo.css';

// 9:16 explainer video with a cover (frame + eyebrow + title + play button) until played.
const ExplainerVideo = ({ src, eyebrow, title }) => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setPlaying(true);
    }
  };

  return (
    <div className="ev">
      {/* #t=0.5 makes the browser paint a frame as the cover */}
      <video
        ref={videoRef}
        src={`${src}#t=0.5`}
        controls={playing}
        playsInline
        preload="metadata"
        onEnded={() => setPlaying(false)}
      />
      {!playing && (
        <button type="button" className="ev__cover" onClick={handlePlay} aria-label={title}>
          <span className="ev__eyebrow">{eyebrow}</span>
          <span className="ev__title">{title}</span>
          <span className="ev__play">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M8 5v14l11-7L8 5z" fill="#103642" />
            </svg>
          </span>
        </button>
      )}
    </div>
  );
};

export default ExplainerVideo;
